import { render, staticRenderFns } from "./ApproveView.vue?vue&type=template&id=2acca29e&"
import script from "./ApproveView.vue?vue&type=script&lang=js&"
export * from "./ApproveView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports